"use client";

import React, { useEffect, useState } from "react";
import { formatUpdatedAgo, formatUpdatedAt } from "@/lib/statsFormat";

// Renders "Last updated: 7 Aug 2026, (10 hours ago)" under a stats block.
//
// Both parts earn their place: the date answers "which snapshot is this?", the
// relative part answers "is it fresh?" at a glance.
//
// The relative string depends on the visitor's clock, so the server cannot
// produce it. We render the date alone first — identical on server and client,
// so hydration matches — then append the relative part after mount.
export default function UpdatedAt({
  iso,
  className = "",
}: {
  iso: string | null;
  className?: string;
}) {
  const absolute = formatUpdatedAt(iso);
  const [ago, setAgo] = useState<string | null>(null);

  useEffect(() => {
    if (!iso) return;
    const tick = () => setAgo(formatUpdatedAgo(iso));
    tick();
    // Refresh while the tab stays open so a long-lived session doesn't keep
    // claiming "1 minute ago" an hour later.
    const id = setInterval(tick, 60_000);
    return () => clearInterval(id);
  }, [iso]);

  if (!absolute) return null;

  return (
    <p className={className}>
      Last updated: {absolute}
      {ago ? `, (${ago})` : ""}
    </p>
  );
}
